export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/face-mesh-edit-worker.35187ebf422ed8b85729.worker.js");
}
